/* istanbul ignore file */
import logoBigDark from 'core/common/assets/images/bigNebulaDark.svg';
import logoBigWhite from 'core/common/assets/images/bigNebulaLight.svg';
import logoDark from 'core/common/assets/images/logoNebulaDark.svg';
import logoWhite from 'core/common/assets/images/logoNebulaWhite.svg';
import { useThemeContext } from 'core/theme/contexts';

export function useLogo() {
  const { isLightTheme } = useThemeContext();

  return {
    logoSrc: isLightTheme ? logoDark : logoWhite,
    logoSrcBig: isLightTheme ? logoBigDark : logoBigWhite,
  };
}
